module.exports = __webpack_public_path__ + "img/Billing.c01cc496.svg";